import { ERPGIcon } from "motw_core/UI/Icons/ERPGIcon";
import * as React from "react";
import { PureComponent } from "react";
import RPGIcon from "source/app/presentation/Shared/RPGIcon/RPGIcon";
import { VerbIcon } from "source/app/presentation/Shared/RPGIcon/VerbIcons.tsx/VerbIcons";
import Data from "../../../../../services/Data";
import { DeleteLogEntryAsync } from "motw_core/Repositories/LogRepository";
import { AreYouSure } from "../../../../../services/Shared/RenderSwal/RenderSwal";
import UI from "../../../../../services/UI/UI";
import { WithAnimatedProgressBarAsync } from "../../../../Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { DeleteDatapointAsync } from "motw_core/Repositories/DatapointRepository";
import { StyleClassAuto } from "../../../../Shared/Styles/Auto/StyleClassAuto";

interface LogEntrySymbolProps {
    entry: string;
    rowId: number;
    goalDatapointId?: number;
    noRightMargin?: boolean;
}

export default class LogEntrySymbol extends PureComponent<LogEntrySymbolProps> {
    state = {
        hover: false,
    };

    constructor(props: any) {
        super(props);
    }

    DeleteEntry = (rowId: number) => {
        const DeleteCalls = async () => {
            await DeleteLogEntryAsync(rowId, ClientDataProvider);

            if (this.props.goalDatapointId) {
                const goalName = this.props.entry.split(" ")[2];
                const datapointId = this.props.goalDatapointId;

                await DeleteDatapointAsync(
                    goalName,
                    datapointId,
                    ClientDataProvider
                );
            }

            await Data.Load.AllAsync();
        };

        AreYouSure("Are you sure?", () =>
            WithAnimatedProgressBarAsync(DeleteCalls)
        );
    };

    render() {
        const verbSymbol = UI.GetEventCategory(this.props.entry);
        const symbolClass = this.props.noRightMargin
            ? StyleClassAuto({
                  alignItems: `center`,
                  display: `flex`,
                  height: `100%`,
                  justifyContent: `center`,
                  lineHeight: 1,
                  marginRight: 0,
                  width: `100%`,
              })
            : StyleClassAuto({
                  flex: `0 0 20px`,
                  marginRight: `10px`,
              });

        return (
            <span
                className={symbolClass}
                onClick={() => this.DeleteEntry(this.props.rowId)}
                onMouseEnter={() => this.setState({ hover: true })}
                onMouseLeave={() => this.setState({ hover: false })}
            >
                {this.state.hover ? (
                    <RPGIcon
                        icon={ERPGIcon.shovel}
                        key={ERPGIcon[ERPGIcon.shovel]}
                    />
                ) : (
                    <VerbIcon verbSymbol={verbSymbol} key={verbSymbol} />
                )}
            </span>
        );
    }
}
